/**
 * 前端统一配置（固定写死，不走环境变量）
 *
 * 后端接口地址：机构端与后端同域名部署（后端 FastAdmin 为 /api 提供接口），
 * 故使用相对路径 '/api'，请求自动跟随页面协议（http/https）及当前域名，避免混合内容与跨域。
 *
 * 说明：机构端静态文件上传到后端站点（public）根目录后，接口即当前域名 /api。
 *
 * 注意：不要用 127.0.0.1 / localhost 访问后端——
 * Apache 按域名路由虚拟主机，IP 访问会落到默认站点导致 404。
 * 如需换到别的机器/环境，只改这里一个地方即可。
 */
export const API_BASE = '/api'
